import { readAuthTokenCookie } from 'Utils/auth/authUtils';
import JwtDecode from 'jwt-decode';

export const CIAM_FLOWS = {
  CHANGE_USERNAME: 'CHANGE_USERNAME',
  CHANGE_EMAIL: 'CHANGE_EMAIL',
  DELETE_USER: 'DELETE_USER',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  PHONE_VERIFY: 'PHONE_VERIFY',
  EMAIL_VERIFY: 'EMAIL_VERIFY'
};

export default class CIAMApiClient {
  constructor() {
    const { COUNTRY, LANGUAGE, API } = CONFIG;
    this.authenticationApiUrl = `${API.CIAM.HOST}/cim/${COUNTRY}/${LANGUAGE}/v1`;
    this.country = COUNTRY;
    this.language = LANGUAGE;
  }

  getRedirectURLForUpdateMobile(partyUid, bearerToken) {
    return this.getRedirectURL(
      partyUid,
      bearerToken,
      CIAM_FLOWS.CHANGE_USERNAME
    );
  }

  getRedirectURLForUpdateEmail(partyUid, bearerToken) {
    return this.getRedirectURL(partyUid, bearerToken, CIAM_FLOWS.CHANGE_EMAIL);
  }

  getRedirectURLForDeleteProfile(partyUid, bearerToken) {
    return this.getRedirectURL(partyUid, bearerToken, CIAM_FLOWS.DELETE_USER);
  }

  getRedirectURLForUpdatePassword(partyUid, bearerToken) {
    return this.getRedirectURL(
      partyUid,
      bearerToken,
      CIAM_FLOWS.CHANGE_PASSWORD
    );
  }

  getRedirectURLForPhoneVerification(partyUid, bearerToken) {
    return this.getRedirectURL(partyUid, bearerToken, CIAM_FLOWS.PHONE_VERIFY);
  }

  getRedirectURLForEmailVerification(partyUid, bearerToken) {
    return this.getRedirectURL(partyUid, bearerToken, CIAM_FLOWS.EMAIL_VERIFY);
  }

  getRedirectURL(partyUid, bearerToken, flow) {
    if (!partyUid || !bearerToken) {
      throw new Error(
        'partyUid and bearerToken are required to get a redirect URL'
      );
    }
    const authTokenCookie = readAuthTokenCookie();
    if (!authTokenCookie) {
      throw new Error('Auth token cookie is required to get a redirect URL');
    }
    const userId = JwtDecode(authTokenCookie).sub;
    try {
      return window.ikea.cie.reauthenticate({
        country: this.country,
        lang: this.language,
        userId,
        flow,
        consumer: 'OWF',
        accessToken: bearerToken
      });
    } catch (error) {
      return false;
    }
  }

  sendOTP(phone, partyUid) {
    if (!partyUid || !phone) {
      throw new Error('User ID and phone number required to send OTP');
    }
    const authTokenCookie = readAuthTokenCookie();
    return fetch(`${this.authenticationApiUrl}/passwordless/start`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authTokenCookie}`
      },
      body: JSON.stringify({
        phoneNumber: phone,
        flow: CIAM_FLOWS.PHONE_VERIFY,
        partyUID: partyUid
      })
    })
      .then(response => {
        if (response.status === 200) {
          return { otp_sent: true };
        }
        if (response.status === 400) {
          return response.json();
        }
        throw Error();
      })
      .then(body => {
        if (body.violations) {
          return {
            otpSentError: {
              response: {
                errors: [{ code: body.violations[0].errorCode }]
              }
            },
            otpSentStatus: false
          };
        }
        return { otpSentStatus: body.otp_sent };
      });
  }

  sendEmail(loginId, partyUid) {
    if (!loginId || !partyUid) {
      throw new Error(
        'Email address and partyUID required to send verification email'
      );
    }
    const authTokenCookie = readAuthTokenCookie();
    return fetch(`${this.authenticationApiUrl}/${partyUid}/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authTokenCookie}`
      },
      body: JSON.stringify({
        email: loginId
      })
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        throw Error();
      })
      .then(body => body.email_sent);
  }
}
